<template>
  <div>
    <div>
      <el-radio-group size="mini" v-model="dateType" @change="dateTypeChange">
          <el-radio-button label="年">年</el-radio-button>
          <el-radio-button label="季">季</el-radio-button>
          <el-radio-button label="月">月</el-radio-button>
      </el-radio-group>
    </div>
    <StackedColumnChart :clientName="clientName" :dateType="dateType" />
  </div>
</template>

<script>

import StackedColumnChart from '@/component/Client/ClientDetail/DataStatistic/StackedColumnChart.vue'

export default {
    name: "ClientPerformance",
    props: {
      clientName: {
        type: String,
        require: true
      }
    },
    components: {
      StackedColumnChart
    },
    data() {
      return {
        dateType: '年'
      }
    },
    methods: {
      dateTypeChange(e){
        console.log(this.dateType)
      }
    }
        
}

</script>
<style scoped>
  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
  }
</style>